import { render, staticRenderFns } from "./AspectTable.vue?vue&type=template&id=572ae9f0&scoped=true&"
import script from "./AspectTable.vue?vue&type=script&lang=js&"
export * from "./AspectTable.vue?vue&type=script&lang=js&"
import style0 from "./AspectTable.vue?vue&type=style&index=0&id=572ae9f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ae9f0",
  null
  
)

export default component.exports